var _circle, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddDocumentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "url(#paint0_linear_0_1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7812 20.8438C22.9271 20.9896 23 21.1667 23 21.375C23 21.5833 22.9271 21.7604 22.7812 21.9062L21.9062 22.7812C21.7604 22.9271 21.5833 23 21.375 23C21.1667 23 20.9896 22.9271 20.8438 22.7812L17.7188 19.6562C17.5729 19.5104 17.5 19.3333 17.5 19.125V18.625C16.3333 19.5417 15 20 13.5 20C11.7083 20 10.1771 19.3646 8.90625 18.0938C7.63542 16.8229 7 15.2917 7 13.5C7 11.7083 7.63542 10.1771 8.90625 8.90625C10.1771 7.63542 11.7083 7 13.5 7C15.2917 7 16.8229 7.63542 18.0938 8.90625C19.3646 10.1771 20 11.7083 20 13.5C20 15 19.5417 16.3333 18.625 17.5H19.125C19.3333 17.5 19.5104 17.5729 19.6562 17.7188L22.7812 20.8438ZM10.6562 16.3438C11.4479 17.1146 12.3958 17.5 13.5 17.5C14.6042 17.5 15.5417 17.1146 16.3125 16.3438C17.1042 15.5521 17.5 14.6042 17.5 13.5C17.5 12.3958 17.1042 11.4583 16.3125 10.6875C15.5417 9.89583 14.6042 9.5 13.5 9.5C12.3958 9.5 11.4479 9.89583 10.6562 10.6875C9.88542 11.4583 9.5 12.3958 9.5 13.5C9.5 14.6042 9.88542 15.5521 10.6562 16.3438Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 1.46222,
    y1: 28.9333,
    x2: 28,
    y2: 2.17778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.335938,
    stopColor: "#7D50FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3969E8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddDocumentIcon);
export default __webpack_public_path__ + "static/media/AddDocumentIcon.5407210d.svg";
export { ForwardRef as ReactComponent };